<template>
  <draggable
    ref="drag"
    v-model="unallocated"
    v-bind="dragOptions"
    multi-drag
    selected-class="multi-drag"
    @update="onUpdate"
    @add="onAdd"
    @remove="onRemove"
    @start="onDragStart"
    @end="onDragEnd"
    style="min-height: 520px"
  >
    <stop-card
      v-for="stop in virtualStopsList"
      :key="stop.id"
      :isCollapsed="isCollapsed"
      :unallocatedStop="stop"
      :selected="selectedStop[stop.id]"
      :isDragable="true"
      @update:selected="$emit('update:selected', stop.id)"
      :class="{ selected: selectedStop[stop.id] }"
    />
    <div v-if="unallocated.length" v-observe-visibility="handleStopsScroll"></div>
    <div class="d-flex justify-center align-center py-3" v-if="unallocated.length == 0">Nenhuma parada encontrada</div>
  </draggable>
</template>

<script>
import StopCard from '@/components/ManualBoardingImport/Stepper/Step5/StopCard.vue';
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
    StopCard
  },
  props: {
    stops: {
      type: Array,
      default: () => []
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    selectedStop: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dragOptions: {
        animation: 150,
        group: 'cargosAllocation',
        ghostClass: 'ghost',
        disabled: false,
        handle: '.handle-drag'
      },
      isDragging: false,
      stopsToShow: 10
    };
  },
  computed: {
    unallocated: {
      get() {
        return this.stops;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    },
    localSelectedNfe: {
      get() {
        return this.selectedStop;
      },
      set(newVal) {
        this.$emit('update:selectedStop', newVal);
      }
    },
    virtualStopsList() {
      return this.unallocated.slice(0, this.stopsToShow);
    }
  },

  methods: {
    onDragStart(e) {
      this.isDragging = true;
      e.item._selected_items = this.unallocated.filter((f) => this.localSelectedNfe[f.id]);
    },
    onDragEnd() {
      this.isDragging = false;
    },
    onUpdate(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        const unallocated = this.unallocated.filter((f) => !ids.includes(f.id));
        unallocated.splice(e.newIndex, 0, ...e.item._selected_items);
        this.unallocated = unallocated;
      }
    },
    onRemove(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        this.unallocated = this.unallocated.filter((f) => !ids.includes(f.id));
      }
    },
    onAdd(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        const unallocated = this.unallocated.filter((f) => !ids.includes(f.id));
        unallocated.splice(e.newIndex, 0, ...e.item._selected_items);
        this.unallocated = unallocated;
      }
    },
    handleStopsScroll(isVisible) {
      if (!isVisible || this.stopsToShow >= this.unallocated.length) return;
      this.stopsToShow += 5;
    }
  }
};
</script>
<style scoped>
.ghost {
  display: none;
}
</style>
